import React, { Component, Fragment, useState, useEffect } from "react";

import { Link } from "react-router-dom";
import { getTransactionhistory } from "../../Features/Transaction/transactionSlice";

import { useDispatch } from "react-redux";
import { useCustomizeContext } from "../../context";
import { useTranslation, I18nextProvider } from "react-i18next";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import circle from '../../assets/images/close-circle.png';
import copy1 from "copy-to-clipboard";
import QRCode from "react-qr-code";
import { Notify } from "notiflix";

import Sidebar from "../../components/Sidebar";

import { useSelector } from "react-redux";


import {
    Modal,
    ModalHeader,

    ModalBody
} from "reactstrap";


const Transaction = (props) => {
    const { t, i18n } = useTranslation();

    const {
        loader: {
            loading, setLoading,
        },
        sideMenu: {
            classIsActive, setClassIsActive
        },
    } = useCustomizeContext();

    const useremail = useSelector((state) => state?.siteSettings?.userDetails?.data?.email)


    let dispatch = useDispatch();
    const [deposit, setDeposit] = useState("deposit")
    const [transactiondata, setTransactiondata] = useState([])

    const [showpage, setShowpage] = useState("10");
    const [depositModal, setDepositModal] = useState(false);
    const [qrdata, setQrdata] = useState({});



    useEffect(() => {
        userTransactionhistory();
    }, [deposit, showpage]);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setClassIsActive(false);
        document.body.classList.remove("SideMenuOpen");
    }, []);



    const userTransactionhistory = async () => {
        let data = {
            page: 1,
            length: Number(showpage),
            type: deposit
        }
        setLoading(true);
        let res = await dispatch(getTransactionhistory(data));
        setTimeout(() => {
            if (res) {
                setTransactiondata(res?.data)
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        }, 1000);
    }

    const depositHistory = (e) => {
        setDeposit(e.target.value)
    }

    const toggleBetDetails = () => {
        setDepositModal(!depositModal);
    };


    const qrcodedata = (data) => {


        setQrdata({
            ...qrdata,
            secure_url: data?.secure_url,
            id: data?.id,
            qr_code: data?.qr_code,
            email: useremail
        });


        toggleBetDetails();

    }


    const copyToClipboard = () => {
        copy1(qrdata?.secure_url);

        Notify.success(`${t("Link copied to clipboard")}`, {
            showOnlyTheLastOne: true,
            clickToClose: true,
            timeout: 1500,
        });

    }


    return (
        <Fragment>
            <Header />
            <div class="mainbody-content">
                <Sidebar />
                <div class="center-maincnt">
                    <div class="inr-container">
                        <div class="center-inrcnt">


                            <div className="transactionpage-maincnt">

                                <section className="transaction_sec">
                                    <div className="tra_total">
                                        <h2 className="mb-4">{t("Transaction")}</h2>

                                        <div className="tra_total_table">
                                            <div className="tra_drp d-flex align-items-center justify-content-between flex-wrap">
                                                <div className="ahm-sel-bx d-flex align-items-center my-2 mr-2">
                                                    <h2 className="mr-2 mb-0">{t("Show")}</h2>
                                                    <div className="form-group mb-0">
                                                        <select className="form-control sec_1" id="exampleFormControlSelect1" onChange={(e) => setShowpage(e.target.value)}>
                                                            <option value="10">10</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>

                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="ahm-sel-bx d-flex align-items-center my-2">
                                                    <h2 className="mr-2 mb-0">{t("Sort By")}</h2>
                                                    <div className="form-group mb-0">
                                                        <select className="form-control sec_2" id="exampleFormControlSelect1" onChange={depositHistory}>
                                                            <option value="deposit">{t("Deposit")}</option>
                                                            <option value="withdraw">{t("Withdraw")}</option>

                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="table-responsive">
                                                <table className="table table-borderless mb-0">
                                                    <thead className="table_head">
                                                        <tr>
                                                            <th>{t("S.no")}</th>
                                                            <th>{t("Date & Time")}</th>
                                                            <th>{t("Currency")}</th>
                                                            <th>{t("Amount")}</th>

                                                            <th>{t("Status")}</th>
                                                        </tr>
                                                    </thead>
                                                    {
                                                        transactiondata?.length > 0 ?
                                                            <tbody className="table_body">


                                                                {transactiondata?.map((element, index) => {
                                                                    return (
                                                                        <tr onClick={() => {
                                                                            qrcodedata(element)
                                                                        }}

                                                                            style={{ "cursor": "pointer" }}
                                                                        >
                                                                            <td>{index + 1}</td>
                                                                            <td>{element?.createdDate}</td>
                                                                            <td>{element?.currency_name}</td>
                                                                            <td>{new Intl.NumberFormat("pt-BR", {
                                                                                style: "currency",
                                                                                currency: "BRL"
                                                                            }).format(element?.amount)

                                                                            }</td>

                                                                            {element?.STATUS == "Pending" ? (
                                                                                <td className="cr_pd">{element?.STATUS}</td>
                                                                            ) : element?.STATUS == "Completed" ? (

                                                                                <td className="cr_grn">{element?.STATUS}</td>

                                                                            ) : (
                                                                                <td className="cr_rd">{element?.STATUS}</td>


                                                                            )

                                                                            }
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                            :
                                                            null
                                                    }
                                                </table>
                                                {
                                                    transactiondata?.length <= 0 ?
                                                        <p className="his_Tbl_Empty">{t("No History Found")}</p>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>


            <Modal
                isOpen={depositModal}
                toggle={toggleBetDetails}
                className="minesmodal-popup"
                autoFocus={false}
                centered
            >

                <ModalBody className="p-0">

                    <div class="minesmodal-content text-white">
                        <div style={{
                            "display": "flex",
                            "justify-content": "space-between"
                        }}>
                            <h2>{t("Transaction")}#{qrdata?.id}</h2>
                            <div >
                                <Link to="#" onClick={toggleBetDetails}>
                                    <img src={circle} alt="" />
                                </Link>
                            </div>
                        </div>

                        <div class="row mt-3">

                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-md-12 text-center">
                                        <div class="mines-detbox text-white">
                                            <QRCode
                                                size={180}
                                                // style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                                // value="hello world"
                                                value={qrdata?.qr_code}
                                            // viewBox={`0 0 256 256`}
                                            />


                                            <h6 className="mt-3">{t("View transaction online")}</h6>
                                            <h6>{t("The customer has already received the transaction at")}</h6>
                                            <h6 className="breakWords">{qrdata?.email}</h6>
                                            <input className="form-control" defaultValue={qrdata?.secure_url} />

                                        </div>

                                    </div>

                                </div>
                                <div class="row mt-3">

                                    <div class="col-sm-12 col-md-12 my-3 my-md-0 mx-auto">
                                        <div class="mines-detmain">
                                            <p style={{ "cursor": "pointer" }} onClick={copyToClipboard}>{t("Copy Link")}</p>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </Fragment>
    );

}

export default Transaction;